export type ReadBalanceBehavior = "None" | "RoundRobin" | "FastestNode";
